import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import PageBanner from "../commoncomponents/Pagebanner";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";

const servicesData = {
  "product-sourcing": {
    title: "Product Sourcing",
    description:
      "We identify and deliver high-quality products from trusted global suppliers.",
  },
  "supplier-verification": {
    title: "Supplier Verification",
    description:
      "Our team conducts in-depth checks to ensure supplier credibility and compliance.",
  },
  "quality-assurance": {
    title: "Quality Assurance",
    animation: "fade-left",
    description: (
      <>
        We implement{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          strict quality control
        </span>{" "}
        measures at every stage of production to ensure your products meet{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          international standards
        </span>{" "}
        and your{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          exact specifications
        </span>
        . Our{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          experienced inspectors
        </span>{" "}
        conduct thorough checks from{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          Sample Matching
        </span>{" "}
        to{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          Container Stuffing inspection
        </span>
        , ensuring every unit is{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>consistent</span>,{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>compliant</span>,
        and{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>defect-free</span>
        . Whether it's{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          sample verification
        </span>
        ,{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          in-line production checks
        </span>
        , or{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          final inspections
        </span>
        , we act as your{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          eyes on the ground
        </span>{" "}
        — delivering complete{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          transparency
        </span>{" "}
        and{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          peace of mind
        </span>
        . With{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>
          Varay QC Services
        </span>
        , <span style={{ fontWeight: "600", color: "#007BFF" }}>quality</span>{" "}
        is not an afterthought — it's built into every step.
      </>
    ),
    subparts: [
      {
        key: "sample-matching",
        title: "Sample Matching",
        link: "/services/quality-assurance/sample-matching",
        image: "/images/SampleMatching.jpeg",
        delay: 400,
      },
      {
        key: "online-inspection",
        title: "Online Inspection",
        link: "/services/quality-assurance/online-inspection",
        image: "/images/onlineInspection2.avif",
        delay: 500,
      },
      {
        key: "offline-inspection",
        title: "Offline Inspection",
        link: "/services/quality-assurance/offline-inspection",
        image: "/images/OfflineInspection2.webp",
        delay: 600,
      },
      {
        key: "container-loading",
        title: "Loading Inspection",
        link: "/services/quality-assurance/container-loading",
        image: "/images/OfflineInspection.jpg",
        delay: 700,
      },
      {
        key: "palletizing-inspection",
        title: "Palletizing Inspection",
        link: "/services/quality-assurance/palletizing-inspection",
        image: "/images/palletizing inspection.jpg",
        delay: 800,
      },
    ],
  },
};

function Services() {
  const { serviceType, subServiceType } = useParams();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const service = servicesData[serviceType];

  if (!service) {
    return <div>Service not found</div>;
  }

  const renderSubService = () => {
    switch (subServiceType) {
      case "sample-matching":
        return <SampleMatching />;
      case "online-inspection":
        return <OnlineInspection />;
      case "offline-inspection":
        return <OfflineInspection />;
      case "container-loading":
        return <ContainerLoading />;
      case "palletizing-inspection":
        return <PalletizingInspection />;
      default:
        return <div>Sub Service Not Found</div>;
    }
  };

  if (serviceType === "product-sourcing" && !subServiceType) {
    return (
      <div>
        <PageBanner title={service.title} />
        <ProductSourcing />
      </div>
    );
  }

  if (serviceType === "supplier-verification" && !subServiceType) {
    return (
      <div>
        <PageBanner title={service.title} />
        <SupplierVerification />
      </div>
    );
  }

  return (
    <div>
      <PageBanner title={service.title} />

      {!subServiceType ? (
        <div className="container px-3 my-5">
          <h2
            className="fw-bold text-center"
            data-aos="fade-left"
            style={{
              fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
              marginTop: "3rem",
              padding: "0 1rem",
            }}
          >
            {service.title}
          </h2>
          <p className="text-muted text-center mb-5">{service.description}</p>

          {service.subparts && (
            <div className="row justify-content-center g-3">
              {service.subparts.map(({ key, image, title, link }, i) => (
                <div
                  key={key}
                  className="col-12 col-sm-6 col-md-4"
                  data-aos="zoom-in"
                  data-aos-delay={100 * (i + 1)}
                >
                  <Link to={link} className="text-decoration-none">
                    <img
                      src={image}
                      alt={title}
                      className="img-fluid rounded"
                      style={{
                        height: "auto",
                        maxHeight: "250px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <h3
                      className="industry-title mt-2"
                      style={{
                        fontFamily:
                          "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        fontWeight: "700",
                        fontSize: "1.6rem",
                        color: "#2c3e50",
                        letterSpacing: "1.1px",
                        marginBottom: "8px",
                        textTransform: "uppercase",
                        borderBottom: "3px solid #3498db",
                        paddingBottom: "4px",
                      }}
                    >
                      {title}
                    </h3>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        renderSubService()
      )}
    </div>
  );
}

export default Services;

//
// Sub-Components (No Reactstrap)
//

function ProductSourcing() {
  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-md-6 mb-3" data-aos="fade-right">
          <img
            src="/images/ProductSourcing.jpg"
            alt="Product Sourcing"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain" }}
          />
        </div>
        <div className="col-md-6" style={{ paddingTop: "1rem" }}>
          <p data-aos="fade-left" className="text-muted">
            At <strong>Varay QC Services</strong>, we specialize in reliable and
            efficient <strong>product sourcing solutions</strong> for businesses
            looking to streamline their supply chains and reduce costs without
            compromising on quality. Whether you're a startup or an established
            company,
            <em>
              {" "}
              we help you find the right manufacturers, suppliers, and products
              from trusted global sources — primarily across Asia and other key
              markets.
            </em>
          </p>
          <p data-aos="fade-left" className="text-muted">
            Our comprehensive sourcing services include supplier identification,
            price negotiation, sample coordination, and full production
            oversight — ensuring your products meet your exact standards before
            they leave the factory.
          </p>
          <p data-aos="fade-left" className="text-muted">
            We act as your local liaison with global insight, providing
            transparency, consistency, and confidence throughout your sourcing
            journey.
          </p>
          <p data-aos="fade-left" className="text-muted">
            Inspired by the legendary Rajhans, we ensure every deal is smooth,
            transparent, and quality-driven. We don’t just inspect products —{" "}
            <strong>we ensure peace of mind.</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

function SupplierVerification() {
  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-md-6 mb-3" data-aos="fade-right">
          <img
            src="/images/SupplierVerification.jpg"
            alt="Supplier Verification"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain" }}
          />
        </div>
        <div className="col-md-6" style={{ paddingTop: "1rem" }}>
          <p data-aos="fade-left" className="text-muted">
            At <span style={{ fontWeight: "600", color: "#007BFF" }}>VQS</span>,
            our <span style={{ fontWeight: "600" }}>Supplier Verification</span>{" "}
            service is designed to protect your business from{" "}
            <span style={{ fontWeight: "600" }}>unreliable vendors</span> and
            ensure you’re working with{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              compliant suppliers
            </span>
            .
          </p>

          <p data-aos="fade-left" className="text-muted">
            We conduct{" "}
            <span style={{ fontWeight: "600" }}>
              thorough background checks
            </span>
            ,{" "}
            <span style={{ fontWeight: "600" }}>legal compliance reviews</span>,
            and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              on-site factory audits
            </span>{" "}
            to verify that your supplier meets{" "}
            <span style={{ fontWeight: "600" }}>international standards</span>{" "}
            and your{" "}
            <span style={{ fontWeight: "600" }}>specific requirements</span>.
          </p>

          <p data-aos="fade-left" className="text-muted">
            Our verification process includes{" "}
            <span style={{ fontWeight: "600" }}>ownership validation</span>,{" "}
            <span style={{ fontWeight: "600" }}>
              production capability analysis
            </span>
            ,{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              certifications review
            </span>
            , and{" "}
            <span style={{ fontWeight: "600" }}>ethical compliance checks</span>{" "}
            — so you can make{" "}
            <span style={{ fontWeight: "600" }}>informed decisions</span> with
            complete{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              confidence
            </span>
            .
          </p>

          <p data-aos="fade-left" className="text-muted">
            With{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              Varay QC Services
            </span>
            , you’re not just sourcing — you're building{" "}
            <span style={{ fontWeight: "600" }}>partnerships</span> on a
            foundation of <span style={{ fontWeight: "600" }}>trust</span>,{" "}
            <span style={{ fontWeight: "600" }}>quality</span>, and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              transparency
            </span>
            .
          </p>

          <p data-aos="fade-left" className="text-muted">
            We help you reduce sourcing risks and improve supplier reliability
            from day one.
          </p>
        </div>
      </div>
    </div>
  );
}

function SampleMatching() {
  return (
    <div className="container my-5">
      <div className="row mb-4">
        <div className="col-md-6" data-aos="fade-right">
          <img
            src="/images/SampleMatching1.jpg"
            alt="Sample Matching 1"
            className="img-fluid"
            style={{ height: "380px", objectFit: "contain", width: "100%" }}
          />
        </div>
        <div className="col-md-6" data-aos="fade-left">
          <img
            src="/images/SM.jpg"
            alt="Sample Matching 2"
            className="img-fluid"
            style={{ height: "381px", objectFit: "contain", width: "100%" }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12" style={{ paddingTop: "1rem" }}>
          <p data-aos="fade-up" className="text-muted">
            At <strong>Varay QC Services</strong>, our{" "}
            <strong>Sample Matching</strong> service is a critical{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>quality</span>{" "}
            control step designed to ensure that your production batches
            perfectly align with the{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              approved prototype samples
            </span>
            . This step helps prevent costly errors by verifying{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              materials
            </span>
            , workmanship, dimensions, colors, and functional features before
            mass production.
          </p>

          <p data-aos="fade-up" data-aos-delay="300" className="text-muted">
            We begin by conducting a comprehensive side-by-side comparison of
            the production samples against your original{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              approved samples
            </span>
            . Our inspectors examine every detail meticulously — including raw
            materials, finishing, measurements, labeling, and packaging — to
            detect even the smallest{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              deviations
            </span>
            .
          </p>

          <p data-aos="fade-up" data-aos-delay="400" className="text-muted">
            If discrepancies are found, we immediately communicate with the
            factory to initiate corrective actions, ensuring that issues are
            resolved before they impact the final production run. This proactive
            approach minimizes risks and helps maintain consistent product{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>quality</span>
            .
          </p>

          <p data-aos="fade-up" data-aos-delay="500" className="text-muted">
            Our expertise spans across various industries and product
            categories, allowing us to customize the sample matching criteria
            based on your unique specifications and industry standards. With{" "}
            <strong>Varay QC Services</strong> as your trusted partner, you gain
            confidence that your products will meet expectations and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              regulatory compliance
            </span>
            .
          </p>

          <p data-aos="fade-up" data-aos-delay="600" className="text-muted">
            Ultimately, sample matching bridges the gap between design and
            production, providing{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              transparency
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              quality assurance
            </span>{" "}
            that safeguards your brand reputation and customer satisfaction.
          </p>
        </div>
      </div>
    </div>
  );
}

function OnlineInspection() {
  return (
    <div className="container my-5">
      <div className="row mb-4">
        <div className="col-md-6" data-aos="fade-right">
          <img
            src="/images/onlineInspection1.jpg"
            alt="On-the-Line Inspection 1"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "100%" }}
          />
        </div>
        <div className="col-md-6" data-aos="fade-left">
          <img
            src="/images/onlineInspection2.avif"
            alt="On-the-Line Inspection 2"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "100%" }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12" style={{ paddingTop: "1rem" }}>
          <p data-aos="fade-up" className="text-muted">
            At <strong>Varay QC Services</strong>, our{" "}
            <strong>On-the-Line Inspection</strong> service ensures{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              real-time
            </span>{" "}
            oversight directly at the point of{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              production
            </span>
            . Our inspectors are present on-site, monitoring processes as they
            happen to maintain consistent{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>quality</span>
            .
          </p>

          <p data-aos="fade-up" data-aos-delay="300" className="text-muted">
            We assess raw materials, assembly methods, workmanship, and
            packaging throughout the production cycle. By identifying issues
            early, we help avoid rework and keep your orders on track.
          </p>

          <p data-aos="fade-up" data-aos-delay="400" className="text-muted">
            This hands-on approach ensures faster issue resolution and helps
            maintain your production timeline without compromising{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              efficiency
            </span>{" "}
            or standards.
          </p>

          <p data-aos="fade-up" data-aos-delay="500" className="text-muted">
            On-the-Line Inspection is ideal for complex products, time-sensitive
            orders, or brands that demand the highest levels of{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>quality</span>{" "}
            and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              transparency
            </span>
            .
          </p>

          <p data-aos="fade-up" data-aos-delay="600" className="text-muted">
            With <strong>Varay QC Services</strong>, you get immediate insights,
            responsive support, and a trusted partner who safeguards your
            product integrity from start to finish.
          </p>
        </div>
      </div>
    </div>
  );
}

function OfflineInspection() {
  return (
    <div className="container my-5">
      <div className="row mb-4">
        <div className="col-md-6" data-aos="fade-right">
          <img
            src="/images/offline2.jpg"
            alt="Offline Inspection 1"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "100%" }}
          />
        </div>
        <div className="col-md-6" data-aos="fade-left">
          <img
            src="/images/OfflineInspection2.webp"
            alt="Offline Inspection 2"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "100%" }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12" style={{ paddingTop: "1rem" }}>
          <p data-aos="fade-up" className="text-muted">
            At <strong>Varay QC Services</strong>, our{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              Offline Inspection
            </span>{" "}
            service involves{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>on-site</span>
            , hands-on product checks conducted by our experienced{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              quality control
            </span>{" "}
            professionals at the{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              manufacturing facility
            </span>
            . This thorough physical inspection ensures your products meet all
            specified requirements before they leave the factory.
          </p>

          <p data-aos="fade-up" data-aos-delay="300" className="text-muted">
            Our inspectors perform{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              detailed checks
            </span>{" "}
            covering raw materials, production processes, assembly quality,
            functionality, labeling, and packaging. We verify conformity with
            your standards and relevant international regulations.
          </p>

          <p data-aos="fade-up" data-aos-delay="400" className="text-muted">
            Any{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              non-conformities
            </span>{" "}
            are documented with photos and reports. We work directly with the
            factory to initiate{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              corrective actions
            </span>
            , ensuring issues are resolved quickly before shipment.
          </p>

          <p data-aos="fade-up" data-aos-delay="500" className="text-muted">
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              Offline Inspection
            </span>{" "}
            is ideal for industries where{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              tactile assessment
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              physical verification
            </span>{" "}
            are critical—such as electronics, textiles, and consumer goods.
          </p>

          <p data-aos="fade-up" data-aos-delay="600" className="text-muted">
            Partnering with <strong>Varay QC Services</strong> means gaining
            reliable, on-the-ground support to protect your{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              brand reputation
            </span>{" "}
            and ensure consistent product quality.
          </p>
        </div>
      </div>
    </div>
  );
}

function ContainerLoading() {
  return (
    <div className="container my-5">
      <div className="row mb-4">
        <div className="col-md-6" data-aos="fade-right">
          <img
            src="/images/OfflineInspection.jpg"
            alt="Container Loading 1"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "100%" }}
          />
        </div>
        <div className="col-md-6" data-aos="fade-left">
          <img
            src="/images/ContainerLoadingSupervision.jpg"
            alt="Container Loading 2"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "100%" }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12" style={{ paddingTop: "1rem" }}>
          <p data-aos="fade-up" className="text-muted">
            At <strong>Varay QC Services</strong>, our{" "}
            <strong>Loading Supervision</strong> service ensures that your goods
            are carefully and correctly loaded into containers, safeguarding
            your products from{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              damage during transit
            </span>{" "}
            and preventing{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              shortages or misplacements
            </span>
            .
          </p>
          <p data-aos="fade-up" data-aos-delay="300" className="text-muted">
            Our{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              trained supervisors
            </span>{" "}
            are present on-site to oversee the entire loading process, verifying
            that{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              packaging is intact
            </span>
            , loading sequences are followed, and containers are{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              sealed properly
            </span>{" "}
            to maintain product integrity.
          </p>
          <p data-aos="fade-up" data-aos-delay="400" className="text-muted">
            We conduct{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              thorough inspections
            </span>{" "}
            to ensure that container conditions meet{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              shipping standards
            </span>
            , and that{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              loading density and weight distribution
            </span>{" "}
            comply with safety regulations, minimizing risks of{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              damage or loss
            </span>
            .
          </p>
          <p data-aos="fade-up" data-aos-delay="500" className="text-muted">
            By choosing <strong>Varay QC Services</strong> for loading
            supervision, you gain{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              peace of mind
            </span>{" "}
            knowing your shipment is handled professionally from factory floor
            to final dispatch, reducing{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              costly claims and delays
            </span>
            .
          </p>
          <p data-aos="fade-up" data-aos-delay="600" className="text-muted">
            Our{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              comprehensive reports
            </span>{" "}
            include photographic evidence and detailed notes, providing{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              full transparency
            </span>{" "}
            and documentation for your{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              records and insurance purposes
            </span>
            .
          </p>
        </div>
      </div>
    </div>
  );
}

function PalletizingInspection() {
  return (
    <div className="container my-5">
      <div className="row mb-4">
        <div className="col-md-6" data-aos="fade-right">
          <img
            src="/images/palletizing-inspection 1.jpg"
            alt="Palletizing Inspection 1"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "120%" }}
          />
        </div>
        <div className="col-md-6" data-aos="fade-left">
          <img
            src="/images/palletizing-inspection 2.png"
            alt="Palletizing Inspection 2"
            className="img-fluid"
            style={{ height: "400px", objectFit: "contain", width: "100%" }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12" style={{ paddingTop: "1rem" }}>
          <p data-aos="fade-up" className="text-muted">
            Proper{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              palletizing
            </span>{" "}
            is crucial for the safe and efficient handling of goods throughout
            the supply chain. Our{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              Palletizing Inspection
            </span>{" "}
            service ensures products are stacked, secured, and arranged on
            pallets in strict compliance with{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              international quality and safety standards
            </span>
            .
          </p>
          <p data-aos="fade-up" data-aos-delay="100" className="text-muted">
            Our experienced inspectors verify{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              correct stacking patterns
            </span>
            , use of{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              securing materials
            </span>
            ,{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              weight limits
            </span>
            , load distribution, and protection of{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              fragile items
            </span>{" "}
            to minimize damage risk.
          </p>
          <p data-aos="fade-up" data-aos-delay="200" className="text-muted">
            We ensure overall{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              stability and safety
            </span>{" "}
            for storage and shipment, reducing costly damages and enhancing
            supply chain efficiency.
          </p>
          <p data-aos="fade-up" data-aos-delay="300" className="text-muted">
            With meticulous inspections and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              comprehensive reporting
            </span>
            , you gain full{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              transparency
            </span>{" "}
            and confidence that your palletized goods will arrive intact and
            ready for their next destination.
          </p>
        </div>
      </div>
    </div>
  );
}
